'use strict';
import React from 'react';
import flux from 'utils/flux';
import {Link} from 'react-router';
import SubmissionLink from './submissionLink'

var HeaderLogin = React.createClass({

    displayName: 'HeaderLogin',

    showLogin(e) {
        e.preventDefault();
        flux.getActions('modals').openModal('Login');
    },

    render() {
        const { allowSubmissions } = flux.getStore('app').getState().config.toJS();

        return (
            <div className="header--inner">
                <Link to="login" className="header__logo">
                    <div className="logo__image">
                        <img src="images/logo_retina.png"/>
                    </div>
                    <div className="logo__divider"></div>
                    <div className="logo__title">
                        <h4>{flux.t('header_title')}</h4>
                    </div>
                </Link>

                <a href="#" className="header__login" onClick={this.showLogin}>
                    {flux.t('login')}
                    <i className="login__icon"></i>
                </a>

                {allowSubmissions && <div className="awards-button__wrapper"><SubmissionLink /></div>}
            </div>
        );
    }
});

module.exports = HeaderLogin;



// WEBPACK FOOTER //
// ./app/components/header/headerLogin.jsx